/**
 * Constants for OpCo Import functionality
 */

export enum DataType {
  ENTITIES = "entities",
  INVESTMENTS = "investments",
  POSITIONS = "positions",
}

export const DATA_TYPE_ORDER_PRIORITY = {
  [DataType.ENTITIES]: 1,
  [DataType.INVESTMENTS]: 2,
  [DataType.POSITIONS]: 3,
};

export const DATA_TYPE_OPTIONS = [
  { value: DataType.ENTITIES, label: "Entities" },
  { value: DataType.INVESTMENTS, label: "Investments" },
  { value: DataType.POSITIONS, label: "Positions" },
];

export const TOOL_TYPE_MAPPING = {
  [DataType.ENTITIES]: "load_investment_entities",
  [DataType.INVESTMENTS]: "load_investment_entities",
  [DataType.POSITIONS]: "load_positions_transactions",
};

export const FILE_PARAMETER_MAPPING = {
  [DataType.ENTITIES]: "entity_file",
  [DataType.INVESTMENTS]: "entity_file",
  [DataType.POSITIONS]: "position_file",
};

export const TOOL_ID_MAPPING = {
  [DataType.ENTITIES]: "load_entities",
  [DataType.INVESTMENTS]: "load_investments",
  [DataType.POSITIONS]: "load_positions",
};
